import React, { useEffect } from 'react';
import setPageMeta from '../../utils/setPageMeta';
import { PAGES } from '../../seo/site';
import CircuitBackground from '../corporate-landing-page/components/CircuitBackground';
import MainframeNavbar from '../corporate-landing-page/components/MainframeNavbar';
import MainframeFooter from '../corporate-landing-page/components/MainframeFooter';
import ServicesHero from './components/ServicesHero';
import DynamicServicesShowcase from './components/DynamicServicesShowcase';
import StackBuilder from './components/StackBuilder';

const ERPSolutionsShowcase = () => {
  useEffect(() => {
    setPageMeta(PAGES.services);
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white text-black overflow-x-hidden" style={{ fontFamily: 'var(--font-body)' }}>
      <CircuitBackground />
      <MainframeNavbar />
      <ServicesHero />
      <DynamicServicesShowcase />
      <StackBuilder />
      <MainframeFooter />
    </div>
  );
};

export default ERPSolutionsShowcase;
